module.exports = __webpack_public_path__ + "static/img/危化品全周期管理系统.6d1ed19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/危化品全周期管理系统.png
// module id = 7iB4
// module chunks = 13